export default function (src) {
  const srcs = ["", "@2x", "@3x"];

  return srcs
    .map((size) => {
      return `${src.split(".").join(`${size}.`)} ${size.replace("@", "")}`;
    })
    .join(",");
}
